<script>
export default {
  data() {
    return {
      filters: {
        available: [
          {
            name: 'Is active',
            query_param: 'is_active',
            options: [
              { label: 'Yes', value: 'true' },
              { label: 'No', value: 'false' }
            ]
          }
        ],
        selected: {}
      }
    }
  },
  methods: {
    parseOption(option) {
      return { label: option.name, value: option.id }
    }
  }
}
</script>
